import React, { Component } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import Home from 'containers/Home/Home';
import Components from 'containers/Components/Components';
import CustomQuestion from 'containers/CustomQuestion/CustomQuestion';
import NPS from 'containers/NPS/NPS';
import OverallAdditionalFeedback from 'containers/OverallAdditionalFeedback/OverallAdditionalFeedback';
import PulseCheck from 'containers/PulseCheck/PulseCheck';
import SubmissionStatus from 'containers/SubmissionStatus/SubmissionStatus';
import TC from 'containers/TC/TC';
import TD from 'containers/TD/TD';
import ThankYou from 'containers/ThankYou/ThankYou';
import TourExperience from 'containers/TourExperience/TourExperience';
import './App.scss';

const App = () => {
    return (
        <main className='main-container'>
            <HashRouter basename='/'>
                <Switch>
                    <Route exact={true} path='/' component={Home} />
                    <Route path='/Components' component={Components} />
                    <Route path='/CustomQuestion/:customPageNumber/:numCustomPages' component={CustomQuestion} />
                    <Route path='/NPS' component={NPS} />
                    <Route path='/OverallAdditionalFeedback' component={OverallAdditionalFeedback} />
                    <Route path='/PulseCheck' component={PulseCheck} />
                    <Route path='/submissionStatus' component={SubmissionStatus} />
                    <Route path='/TC' component={TC} />
                    <Route path='/TD/:tdPageNumber/:numTdPages' component={TD} />
                    <Route path='/ThankYou' component={ThankYou} />
                    <Route path='/TE' component={TourExperience} />
                    <Route path='*' component={Home} />
                </Switch>
            </HashRouter>
        </main>
    );
};

export default App;



// WEBPACK FOOTER //
// ./application/containers/App/App.jsx